import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from "vee-validate";
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import SelectList from "@/components/forms/SelectList.vue";
import { HierarchyTagStore } from "@/types/HierarchyTag";
import { ReportFilter, UnitValuesReportConfig } from "@/types/Report";


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitValuesConfig',
  props: {
    config: {},
    filters: {},
    hierarchyTags: {}
  },
  emits: ["configChange"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n();
const { defineField } = useForm();

const availableHierarchyTags = ref<string[]>([]);

const [aggregationLevel] = defineField("aggregationLevel");

watch(
  () => props.config,
  () => {
    aggregationLevel.value = props.config.aggregation_level;

    availableHierarchyTags.value = Array.from(
      new Set(props.hierarchyTags.map((tag) => tag.type).filter((tag) => tag !== "component")),
    ).sort((a, b) =>
      a === "building" ? -1 : b === "building" ? 1 : a === "level" ? -1 : b === "level" ? 1 : 0,
    );
  },
  { immediate: true },
);

const handleConfigChange = () => {
  const config: UnitValuesReportConfig = {
    aggregation_level: aggregationLevel.value,
  };
  emit("configChange", config);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SelectList, {
    options: 
      availableHierarchyTags.value.map((tag) => ({
        name: _unref(t)(`analytics.reports.${tag}`),
        value: tag,
      }))
    ,
    name: "aggregationLevel",
    defaultSelected: _unref(aggregationLevel),
    label: _unref(t)('analytics.reports.aggregation_level'),
    class: "mb-3",
    "onUpdate:selected": (value) => (aggregationLevel.value = value, handleConfigChange()) 
  }, null, 8, ["options", "defaultSelected", "label", "onUpdate:selected"]))
}
}

})